import { CSSProperties, FC } from "react";
// import style from "./component.module.scss";
import { Box, Button, Typography } from "@mui/material";
import QuestionCircleSvg from "@/assets/svg/QuestionCircleSvg";
import theme from "@/theme";
import CheckSvg from "@/assets/svg/CheckSvg";
import AtmSvg from "@/assets/svg/AtmSvg";
import { style } from "../stylesCreatePostModal";
import CashFastCircle from "@/assets/svg/CashFastCircle";

interface IInfoPanelProps {
  showPublishRequirements: any;
  togglePublishRequirements: any;
  postVariant: any;
  validationState: {
    hasValidCashtag: boolean;
    hasSubtype: boolean;
    hasSource: boolean;
    isButtonActive: boolean;
  };
}

const InfoPanel: FC<IInfoPanelProps> = ({
  showPublishRequirements,
  togglePublishRequirements,
  postVariant,
  validationState,
}) => {
  console.log(validationState);

  return (
    <div
      style={
        showPublishRequirements
          ? (style.modalInfoOpen as CSSProperties)
          : (style.modalInfoClose as CSSProperties)
      }
    >
      {showPublishRequirements ? (
        <Box>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }} gap={"0.5rem"}>
                <AtmSvg color="primary" width={24} height={24} />
                <Typography variant="h4" fontWeight={500} color={theme.palette.custom.blueGray900}>
                  To publish a {postVariant === "Stocks" ? "Stock" : "Economics"} post, you need:
                </Typography>
              </Box>
              <Button
                variant="text"
                color="primary"
                onClick={togglePublishRequirements}
                sx={style.hideButton}
              >
                Hide
              </Button>
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              {postVariant === "Stocks" && (
                <>
                  <Box sx={{ display: "flex", alignItems: "center", height: "20px" }}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "1px",
                      }}
                    >
                      <CheckSvg
                        fontSize="small"
                        color={
                          validationState.hasValidCashtag
                            ? theme.palette.custom.secondaryGreenLight
                            : theme.palette.custom.blueGray600
                        }
                        width={20}
                        height={20}
                      />
                    </Box>

                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        color: validationState.hasValidCashtag
                          ? theme.palette.custom.secondaryGreenLight
                          : theme.palette.custom.blueGray600,
                        display: "inline",
                      }}
                    >
                      Use the cashtag
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                          transform: "translateY(2px",
                        }}
                      >
                        <CashFastCircle width={16} height={16} />
                      </span>
                      before symbol e.g{" "}
                      <Typography
                        fontSize={"1rem"}
                        fontWeight={600}
                        component={"span"}
                        color={theme.palette.custom.mainBlue}
                      >
                        $SYMBL
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "1px",
                      }}
                    >
                      <CheckSvg
                        fontSize="small"
                        color={
                          validationState.hasSource
                            ? theme.palette.custom.secondaryGreenLight
                            : theme.palette.custom.blueGray600
                        }
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        color: validationState.hasSource
                          ? theme.palette.custom.secondaryGreenLight
                          : theme.palette.custom.blueGray600,
                      }}
                    >
                      Include a source for your post, either a link to your source, or relevant
                      image or screenshot, such as a price chart.
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "1px",
                      }}
                    >
                      <CheckSvg
                        fontSize="small"
                        color={
                          validationState.hasSubtype
                            ? theme.palette.custom.secondaryGreenLight
                            : theme.palette.custom.blueGray600
                        }
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        color: validationState.hasSubtype
                          ? theme.palette.custom.secondaryGreenLight
                          : theme.palette.custom.blueGray600,
                      }}
                    >
                      Select{" "}
                      <Typography
                        fontSize={"1rem"}
                        fontWeight={600}
                        component={"span"}
                        color={theme.palette.custom.mainBlue}
                      >
                        #fundamental{" "}
                      </Typography>
                      or{" "}
                      <Typography
                        fontSize={"1rem"}
                        fontWeight={600}
                        component={"span"}
                        color={theme.palette.custom.mainBlue}
                      >
                        #technical{" "}
                      </Typography>{" "}
                      or both.
                    </Box>
                  </Box>
                </>
              )}
              {postVariant === "Economics" && (
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "1px",
                      }}
                    >
                      <CheckSvg
                        fontSize="small"
                        color={
                          validationState.isButtonActive
                            ? theme.palette.custom.secondaryGreenLight
                            : theme.palette.custom.blueGray600
                        }
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        color: validationState.isButtonActive
                          ? theme.palette.custom.secondaryGreenLight
                          : theme.palette.custom.blueGray600,
                      }}
                    >
                      Include a source for your post, either a link to your source, or relevant
                      image or screenshot, such as a price chart.
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={style.howToPublishWrapper}>
          <Button
            startIcon={<QuestionCircleSvg width={24} height={24} />}
            onClick={togglePublishRequirements}
            color="primary"
            sx={style.howToPublishButton}
          >
            How to publish?
          </Button>
        </Box>
      )}
    </div>
  );
};

export default InfoPanel;
